export const DEFAULT_ATTENDANCE_OPTIONS = [
  { id: "coming", text: "Буду", forecast: "coming" },
  { id: "late", text: "Буду, но опоздаю", forecast: "coming" },
  { id: "not_coming", text: "Не буду", forecast: "not_coming" },
];

export function pollTypeLabel(type) {
  if (type === "feedback") return "Обратная связь";
  if (type === "custom") return "Анкета";
  return "Подтверждение явки";
}

export function pollStatusLabel(status) {
  if (status === "closed") return "Завершён";
  return "Активен";
}

export function rosterStatusClass(status) {
  if (status === "coming") return "coming";
  if (status === "not_coming") return "notComing";
  if (status === "unknown") return "unknown";
  return "muted";
}

export function defaultClosesAtFromSession(sessionIso) {
  if (!sessionIso) return "";
  const d = new Date(sessionIso);
  d.setHours(d.getHours() - 1);
  return toDatetimeLocalValue(d);
}

export function defaultClosesAtFromDatetime(datetimeLocal) {
  if (!datetimeLocal) return "";
  const d = new Date(datetimeLocal);
  if (Number.isNaN(d.getTime())) return "";
  d.setHours(d.getHours() - 1);
  return toDatetimeLocalValue(d);
}

function toDatetimeLocalValue(d) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
